import React from 'react';
import './App.css';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import SplashScreen from './components/SplashScreen';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Destinations from './components/Destinations';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';

const MainContent = () => {
  const { showSplash } = useLanguage();

  if (showSplash) {
    return <SplashScreen />;
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Destinations />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <MainContent />
    </LanguageProvider>
  );
}

export default App;
